module.exports = __webpack_public_path__ + "static/media/story-23.4a050895.jpg";